import { PAYEX_URL } from 'constants/config';
import { fetchJson } from 'utils/fetchJson/fetchJson';
import { SourceOfFundsResponse } from './types';

const sourceOfFunds = {
  get: () => {
    const path = `${PAYEX_URL}/source_of_funds`;
    return fetchJson<SourceOfFundsResponse>(path);
  },
};

export { sourceOfFunds };
